import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountUsageUnitsQuery($filters: [Filter], $companyId: ID!) {
    Me {
      id
      Company(id: $companyId) {
        data: countUsageUnits(options: { filters: $filters })
      }
    }
  }
`
